const settings = {
    selector: '.header',
};

/* ------------- *
 * Module Export *
 * ------------- */
/* eslint-disable */

const UTMTracking = {
    selector: settings.selector,

    getCookie(cname) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    setCookie(cname, cvalue, exdays){
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        //document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        //expire cookie after browser close
        document.cookie = cname + "=" + cvalue;
    },

    init(selector = settings.selector) {
        let queryParams = new URLSearchParams(window.location.search);
        let allowedParams = ['utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term'];
        let allowedParamsFieldNames = ['utmSource','utmMedium', 'utmCampaign','utmId','utmContent','utmTerm'];
        if(document.referrer.indexOf(document.location.hostname) == -1 && document.referrer != ''){
            this.setCookie('tsd_referrer',document.referrer,1);
        }
        for(let i=0; i < allowedParams.length; i++) {
            let activeObj = allowedParams[i];
            let utmsrc = queryParams.get(activeObj);
            if (utmsrc) {
                this.setCookie('tsd_' + allowedParamsFieldNames[i],queryParams.get( allowedParams[i]),1);
            }
        }
        let isFreeForm = document.getElementById('form-input-formName');
        if( isFreeForm && isFreeForm.value == 'Conviron Contact Us Form'){
            window.addEventListener('DOMContentLoaded', (event) => {
                for(let i=0; i < allowedParams.length; i++) {
                    document.getElementsByName(allowedParamsFieldNames[i])[0].value = this.getCookie('tsd_' + allowedParamsFieldNames[i]);
                }
                let refValue = this.getCookie('tsd_referrer');
                if (refValue.length == 0){
                    refValue = 'direct';
                }
                document.getElementsByName('referrer')[0].value = refValue;
            });
        }
    },
};

export default UTMTracking;
